import React from "react";
import styled from "styled-components";

const RadioButton = styled.div`
  font-size: 13px;
  padding-left: 10px;
  margin-right: 5px;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
`;

function RadioButtonWithText({ text = "", checked = false, value = "", name }) {
  return (
    <RadioButton>
      <input value={value} checked={checked} type="radio" name={name} />
      <label>{text}</label>
    </RadioButton>
  );
}

export default RadioButtonWithText;
